export const REALTIME_CONFIG = {
  RECONNECTION_DELAY: 1000,
  MAX_RECONNECTION_DELAY: 5000,
  MAX_RECONNECTION_ATTEMPTS: 5,
} as const;

export const REALTIME_TRANSPORTS = {
  WEBSOCKET: 'websocket',
  POLLING: 'polling',
} as const;

// Internal status events — dispatched locally, never sent to/from the socket server.
export const REALTIME_EVENTS = {
  CONNECTED: 'realtime:connected',
  DISCONNECTED: 'realtime:disconnected',
  RECONNECTING: 'realtime:reconnecting',
  ERROR: 'realtime:error',
} as const;
